import { fetchManageColumnsThunk } from './fetchManageColumnsThunk';
export default fetchManageColumnsThunk;
